import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { setPageSeo, resetPageSeo, SEO_BASE } from "@/lib/seo";

// Parcours simplifié Toussaint 2026 — page d'accueil (étape 1), sans connexion.
export default function ToussaintLanding() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setPageSeo({
      title: t("tss.seoTitle"),
      ogTitle: "Cliquez sur cette image",
      description: t("tss.seoDesc"),
      ogDescription: "Partage gratuitement avec tes proches et amis.",
      canonicalPath: "/toussaint-2026",
      image: `${SEO_BASE}/toussaint-2026-share.jpg`,
      imageWidth: "1200",
      imageHeight: "630",
      ogType: "website",
    });
    return () => resetPageSeo();
  }, [t, i18n.language]);

  return (
    <div className="relative flex min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-black px-6 text-center" data-testid="toussaint-landing">
      <div className="absolute right-4 z-20" style={{ top: "calc(1rem + env(safe-area-inset-top))" }} data-testid="toussaint-landing-lang"><LanguageSwitcher /></div>
      {/* Fond */}
      <div className="absolute inset-0">
        <img src="/toussaint-hero.jpg" alt="" aria-hidden="true" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" />
      </div>

      <div className="relative z-10 flex w-full max-w-2xl flex-col items-center">
        <img
          src="/toussaint-logo.png"
          alt={t("tss.logoAlt")}
          className="w-full max-w-md"
          data-testid="toussaint-landing-logo"
        />

        <p className="mt-10 max-w-2xl text-lg leading-loose text-white/90 sm:text-2xl sm:leading-loose" data-testid="toussaint-landing-intro">
          {t("tss.landingIntro")}
        </p>

        <Button
          onClick={() => navigate("/toussaint-2026/allumer")}
          data-testid="toussaint-landing-cta"
          className="mt-10 h-14 rounded-full bg-primary px-10 text-lg font-semibold shadow-[0_4px_28px_0_rgba(56,189,248,0.5)] transition-transform hover:scale-[1.03]"
        >
          <Flame size={20} className="mr-2" /> {t("tss.ctaBtn")}
        </Button>
      </div>
    </div>
  );
}
